import { StatusTone } from '@/components/ui/statusTone.ts';
import { AvailabilityFieldDto } from '@/features/dashboard/tours/types/AvailabilityFieldDto.ts';
import {
  isFull,
  occupancyPercent,
} from '@/features/dashboard/tours/types/availability.utils.ts';
import { OptionOccupancyStatus } from '@/features/dashboard/tours/types/dashboard/optionOccupancyStatus.ts';

interface OptionOccupancyStatusDisplay {
  label: string;
  tone: StatusTone;
}

export const OPTION_OCCUPANCY_STATUS_DISPLAY: Record<
  OptionOccupancyStatus,
  OptionOccupancyStatusDisplay
> = {
  [OptionOccupancyStatus.FULL]: { label: 'Pełna', tone: 'error' },
  [OptionOccupancyStatus.ALMOST_FULL]: {
    label: 'Prawie pełna',
    tone: 'warning',
  },
  [OptionOccupancyStatus.EMPTY]: { label: 'Brak zapisów', tone: 'neutral' },
  [OptionOccupancyStatus.OPEN]: { label: 'Otwarta', tone: 'success' },
};

/**
 * Kolejność progów jest znacząca: komplet wygrywa z „prawie pełna”, a pustka
 * przegrywa z jednym i drugim — opcja bez limitu i bez zapisów jest pusta,
 * ale pełna nigdy nie będzie.
 */
export const getOptionOccupancyStatus = (
  availability: AvailabilityFieldDto,
): OptionOccupancyStatus => {
  if (isFull(availability)) return OptionOccupancyStatus.FULL;

  const percent = occupancyPercent(availability);
  if (percent !== null && percent >= 75)
    return OptionOccupancyStatus.ALMOST_FULL;

  if (availability.currentCount === 0) return OptionOccupancyStatus.EMPTY;

  return OptionOccupancyStatus.OPEN;
};

export const getOptionOccupancyStatusDisplay = (
  availability: AvailabilityFieldDto,
): OptionOccupancyStatusDisplay =>
  OPTION_OCCUPANCY_STATUS_DISPLAY[getOptionOccupancyStatus(availability)];
